var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIconSolid = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5625 0 0 3.59375 0 8C0 12.4375 3.5625 16 8 16C12.4062 16 16 12.4375 16 8C16 3.59375 12.4062 0 8 0ZM8 4C8.53125 4 9 4.46875 9 5C9 5.5625 8.53125 6 8 6C7.4375 6 7 5.5625 7 5C7 4.46875 7.4375 4 8 4ZM9.25 12H6.75C6.3125 12 6 11.6875 6 11.25C6 10.8438 6.3125 10.5 6.75 10.5H7.25V8.5H7C6.5625 8.5 6.25 8.1875 6.25 7.75C6.25 7.34375 6.5625 7 7 7H8C8.40625 7 8.75 7.34375 8.75 7.75V10.5H9.25C9.65625 10.5 10 10.8438 10 11.25C10 11.6875 9.65625 12 9.25 12Z",
    fill: "#007FAD"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIconSolid);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMEMzLjU2MjUgMCAwIDMuNTkzNzUgMCA4QzAgMTIuNDM3NSAzLjU2MjUgMTYgOCAxNkMxMi40MDYyIDE2IDE2IDEyLjQzNzUgMTYgOEMxNiAzLjU5Mzc1IDEyLjQwNjIgMCA4IDBaTTggNEM4LjUzMTI1IDQgOSA0LjQ2ODc1IDkgNUM5IDUuNTYyNSA4LjUzMTI1IDYgOCA2QzcuNDM3NSA2IDcgNS41NjI1IDcgNUM3IDQuNDY4NzUgNy40Mzc1IDQgOCA0Wk05LjI1IDEySDYuNzVDNi4zMTI1IDEyIDYgMTEuNjg3NSA2IDExLjI1QzYgMTAuODQzOCA2LjMxMjUgMTAuNSA2Ljc1IDEwLjVINy4yNVY4LjVIN0M2LjU2MjUgOC41IDYuMjUgOC4xODc1IDYuMjUgNy43NUM2LjI1IDcuMzQzNzUgNi41NjI1IDcgNyA3SDhDOC40MDYyNSA3IDguNzUgNy4zNDM3NSA4Ljc1IDcuNzVWMTAuNUg5LjI1QzkuNjU2MjUgMTAuNSAxMCAxMC44NDM4IDEwIDExLjI1QzEwIDExLjY4NzUgOS42NTYyNSAxMiA5LjI1IDEyWiIgZmlsbD0iIzAwN0ZBRCIvPgo8L3N2Zz4K";